import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { PIS_DEPOSIT_EVENTS, PIS_DEPOSITS } from 'api/react-query/keys'
import { inspectPisDeposit, listPisDepositEvents, listPisDeposits } from './endpoints'

export const usePisDeposits = (customerId: string) =>
  useQuery({
    queryKey: [PIS_DEPOSITS, customerId],
    queryFn: () => listPisDeposits(customerId),
  })

export const usePisDepositEvents = (customerId: string, depositId: string | undefined) =>
  useQuery({
    queryKey: [PIS_DEPOSIT_EVENTS, customerId, depositId],
    queryFn: () => listPisDepositEvents(customerId, depositId as string),
    enabled: !!depositId,
  })

// A mutation rather than a query: inspecting polls the bank live and corrects the stored state
// when it differs, so the list and event history must be refreshed afterwards.
export const usePisDepositInspection = (customerId: string, depositId: string | undefined) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => inspectPisDeposit(customerId, depositId as string),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [PIS_DEPOSITS, customerId],
      })
      await queryClient.invalidateQueries({
        queryKey: [PIS_DEPOSIT_EVENTS, customerId, depositId],
      })
    },
  })
}
